import { render, staticRenderFns } from "./WithBottomOffset.vue?vue&type=template&id=20f249c6"
import script from "./WithBottomOffset.vue?vue&type=script&lang=js"
export * from "./WithBottomOffset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports